module.exports = __webpack_public_path__ + "static/media/Volume.957faba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/icons/Volume.png
// module id = 965
// module chunks = 0